import { useMemo } from "react";
import { useQuery } from "urql";
import { graphql } from "@acto/gql";
import { MeetingSeries } from "@acto/taskpane/core/domain";
import { MeetingScope } from "@acto/gql/graphql";

const RecurringMeetingsQuery = graphql(`
  query GetRecurringMeetings($clientId: ID!, $scope: MeetingScope) {
    recurringMeetings(clientId: $clientId, scope: $scope) {
      id
      __typename
      cadence
      startDate
      until
      scheduledStartTime
      scheduledEndTime
      nextOccurrence {
        id
        __typename
        scheduledDate
        occurrenceDate
        scheduledStartTime
        scheduledEndTime
        owner {
          id
          __typename
          name
          employee {
            id
            __typename
            name
          }
        }
      }
    }
  }
`);

export function useRecurringMeetings({
  clientId,
  scope = MeetingScope.Owned,
}: {
  clientId?: string;
  /** See `useMeetings`' `scope`. */
  scope?: MeetingScope;
}) {
  const clientScoped = scope === MeetingScope.ClientAccess;
  const [result, refetch] = useQuery({
    query: RecurringMeetingsQuery,
    variables: { clientId: clientId ?? "", ...(clientScoped && { scope }) },
    pause: !clientId,
  });

  const series = useMemo(() => result.data?.recurringMeetings.map(MeetingSeries.fromGraphql), [result.data]);

  return {
    data: series,
    isFetching: result.fetching || Boolean(result.stale),
    isPending: (result.fetching || Boolean(result.stale)) && !result.data,
    error: result.error,
    refetch,
  };
}
